import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/suncore/build/20261104T102900Z-fec39489/app/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/opt/suncore/build/20261104T102900Z-fec39489/app/layouts/login.vue").then(m => m.default || m))
}